var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero'),_c('features2'),_c('features3'),_c('features4'),_c('tour2'),_c('l-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }